import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import { useCallback, useState } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);

/** Rango [lunes 00:00, domingo 23:59:59] de la semana del día calendario `date`, medido en `ianaTimezone`. */
export function getWeekRange(date: Dayjs, ianaTimezone: string) {
  const day = dayjs.tz(date.format("YYYY-MM-DD"), ianaTimezone);
  return {
    startTs: day.weekday(0).startOf("day").unix(),
    stopTs: day.weekday(6).endOf("day").unix(),
  };
}

/**
 * Semana seleccionada. `selectedDate` es un día calendario (sin zona) y `range` su semana en
 * `ianaTimezone`, así el rango no depende de la zona del navegador.
 */
export function useWeekRange(ianaTimezone: string) {
  const [selectedDate, setSelectedDate] = useState<Dayjs>(() => dayjs(dayjs().tz(ianaTimezone).format("YYYY-MM-DD")));
  const [range, setRange] = useState(() => getWeekRange(selectedDate, ianaTimezone));

  const setWeekByDate = useCallback((newDate: Dayjs) => {
    setSelectedDate(newDate);
    setRange(getWeekRange(newDate, ianaTimezone));
  }, [ianaTimezone]);

  const navigateWeek = useCallback((direction: 1 | -1) => {
    const newDate = selectedDate.add(direction, 'week');
    setWeekByDate(newDate);
  }, [selectedDate, setWeekByDate]);

  return {
    selectedDate,
    range,
    setWeekByDate,
    navigateWeek,
    previousWeek: () => navigateWeek(-1),
    nextWeek: () => navigateWeek(1)
  };
}
